const LoginBanner = (props) => {
  if (props.env === "staging") {
    return (
        <div className="flex justify-center p-[10rem]">
        <h1>
        <img alt="Intel Innovation, September 27-28, 2022, San Jose" className="m-auto" src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/innovation%20hero%20banner%20logo_1659554228827001c7ne.png"/>
        </h1>
        </div>
    );
  } else if (props.env === "prod") {
    return (
        <div className="flex justify-center">
        <h1>
        <img alt="Intel Innovation, September 27-28, 2022, San Jose" className="m-auto" src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/innovation%20hero%20banner%20logo_1659554228827001c7ne.png"/>
        </h1>
        </div>
    );
  }
};
export default LoginBanner;
